// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
/* .create-formation-modal {
    padding: var(--space-half) var(--space-and-half);
} */
/* .create-formation-modal__header {
    display: flex;
    align-items: center;
    padding: var(--space);
    background: var(--white-color);
    box-shadow: var(--shadow-card-2);
}
p.create-formation-modal__header__title {
    margin-right: var(--space);
    color: var(--primary-dark-color) !important;
}
.create-formation-modal__header__button {
    margin-right: var(--space-half);
}
.create-formation-modal__content {
    padding: var(--space-x2) var(--space-x2-and-half);
    overflow-y: scroll;
    max-height: 550px;
    position: relative;
}
.create-formation-modal__content__media {
    position: relative;
    width: 100%;
}
.create-formation-modal__content__media img {
    height: 100%;
}
.create-formation-modal__content__result {
    position: relative;
    height: 400px;
    width: 100%;
    display: flex;
    justify-content: center;
}
.create-formation-modal__content__result__container {
    position: relative;
    height: 100%;
}
.new-formation__content__result__container__remove {
    position: revert;
    right: var(--space);
    top: var(--space);
}
.create-formation-modal__content__result img {
    height: 100%;
}
 */
.create-formation-modal__form {
    background: var(--white-color);
    width: 100%;
    display: flex;
    justify-content: flex-end;
    padding: var(--space-and-half);
}
.create-formation-modal__form input {
    width: 100%;
}
.create-formation-modal__form__form {
    display: flex;
    flex-direction: column;
}
.create-formation-modal__form__field {
    margin: 0 !important;
}
.create-formation-modal__form__field input {
    margin: 0;
}
.create-formation-modal__form__group {
    display: flex;
    justify-content: flex-end;
}
.create-formation-modal__form__submit {
    align-self: flex-end;
    margin-left: var(--space);
}

.create-formation-modal .modal2__header__close {
    order: 1;
}

.create-formation-modal .modal2__header__title {
    order: 2;
    padding-top: 0;
    margin-left: var( --space );
}

.create-formation-modal .modal2__header__clear-btn {
    order: 3;
}

.create-formation-modal .icon-arrow-left {
    font-size: var( --space-and-half );
}

.create-formation-modal__form__group .secondary-button {
    border-color: var( --error-color );
    color: var( --error-color );

}

.create-formation-modal__form__group .secondary-button:active {
    background-color: var(--disabled-sb-bg-color);
}

.create-formation-modal__form__group .secondary-button:hover {
    background-color: var(--disabled-sb-bg-color);
}

.create-formation-modal__form__group .secondary-button:focus {
    background-color: var(--disabled-sb-bg-color);
}
`, "",{"version":3,"sources":["webpack://./src/app/posts/components/create-formation-modal/CreateFormationModalComponent.styles.css"],"names":[],"mappings":";AACA;;GAEG;AACH;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EA8CE;AACF;IACI,8BAA8B;IAC9B,WAAW;IACX,aAAa;IACb,yBAAyB;IACzB,8BAA8B;AAClC;AACA;IACI,WAAW;AACf;AACA;IACI,aAAa;IACb,sBAAsB;AAC1B;AACA;IACI,oBAAoB;AACxB;AACA;IACI,SAAS;AACb;AACA;IACI,aAAa;IACb,yBAAyB;AAC7B;AACA;IACI,oBAAoB;IACpB,yBAAyB;AAC7B;;AAEA;IACI,QAAQ;AACZ;;AAEA;IACI,QAAQ;IACR,cAAc;IACd,2BAA2B;AAC/B;;AAEA;IACI,QAAQ;AACZ;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,kCAAkC;IAClC,2BAA2B;;AAE/B;;AAEA;IACI,6CAA6C;AACjD;;AAEA;IACI,6CAA6C;AACjD;;AAEA;IACI,6CAA6C;AACjD","sourcesContent":["\n/* .create-formation-modal {\n    padding: var(--space-half) var(--space-and-half);\n} */\n/* .create-formation-modal__header {\n    display: flex;\n    align-items: center;\n    padding: var(--space);\n    background: var(--white-color);\n    box-shadow: var(--shadow-card-2);\n}\np.create-formation-modal__header__title {\n    margin-right: var(--space);\n    color: var(--primary-dark-color) !important;\n}\n.create-formation-modal__header__button {\n    margin-right: var(--space-half);\n}\n.create-formation-modal__content {\n    padding: var(--space-x2) var(--space-x2-and-half);\n    overflow-y: scroll;\n    max-height: 550px;\n    position: relative;\n}\n.create-formation-modal__content__media {\n    position: relative;\n    width: 100%;\n}\n.create-formation-modal__content__media img {\n    height: 100%;\n}\n.create-formation-modal__content__result {\n    position: relative;\n    height: 400px;\n    width: 100%;\n    display: flex;\n    justify-content: center;\n}\n.create-formation-modal__content__result__container {\n    position: relative;\n    height: 100%;\n}\n.new-formation__content__result__container__remove {\n    position: revert;\n    right: var(--space);\n    top: var(--space);\n}\n.create-formation-modal__content__result img {\n    height: 100%;\n}\n */\n.create-formation-modal__form {\n    background: var(--white-color);\n    width: 100%;\n    display: flex;\n    justify-content: flex-end;\n    padding: var(--space-and-half);\n}\n.create-formation-modal__form input {\n    width: 100%;\n}\n.create-formation-modal__form__form {\n    display: flex;\n    flex-direction: column;\n}\n.create-formation-modal__form__field {\n    margin: 0 !important;\n}\n.create-formation-modal__form__field input {\n    margin: 0;\n}\n.create-formation-modal__form__group {\n    display: flex;\n    justify-content: flex-end;\n}\n.create-formation-modal__form__submit {\n    align-self: flex-end;\n    margin-left: var(--space);\n}\n\n.create-formation-modal .modal2__header__close {\n    order: 1;\n}\n\n.create-formation-modal .modal2__header__title {\n    order: 2;\n    padding-top: 0;\n    margin-left: var( --space );\n}\n\n.create-formation-modal .modal2__header__clear-btn {\n    order: 3;\n}\n\n.create-formation-modal .icon-arrow-left {\n    font-size: var( --space-and-half );\n}\n\n.create-formation-modal__form__group .secondary-button {\n    border-color: var( --error-color );\n    color: var( --error-color );\n\n}\n\n.create-formation-modal__form__group .secondary-button:active {\n    background-color: var(--disabled-sb-bg-color);\n}\n\n.create-formation-modal__form__group .secondary-button:hover {\n    background-color: var(--disabled-sb-bg-color);\n}\n\n.create-formation-modal__form__group .secondary-button:focus {\n    background-color: var(--disabled-sb-bg-color);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
